var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.metaData !== null
        ? _c(
            "div",
            {
              attrs: { itemscope: "", itemtype: "https://schema.org/Product" }
            },
            [
              _vm.metaData.product.sku !== null
                ? _c("meta", {
                    attrs: {
                      itemprop: "sku",
                      content: _vm.metaData.product.sku
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.metaData.product.gtin14 !== ""
                ? _c("meta", {
                    attrs: {
                      itemprop: "gtin14",
                      content: _vm.metaData.product.gtin14
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("meta", {
                attrs: {
                  itemprop: "category",
                  content: _vm.metaData.product.category
                }
              }),
              _vm._v(" "),
              _c("meta", {
                attrs: { itemprop: "name", content: _vm.metaData.product.name }
              }),
              _vm._v(" "),
              _c("meta", {
                attrs: {
                  itemprop: "description",
                  content: _vm.metaData.product.description
                }
              }),
              _vm._v(" "),
              _c("meta", {
                attrs: {
                  itemprop: "image",
                  content: _vm.metaData.product.image
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  attrs: {
                    itemprop: "offers",
                    itemscope: "",
                    itemtype: "https://schema.org/Offer"
                  }
                },
                [
                  _c("meta", {
                    attrs: {
                      itemprop: "url",
                      content: _vm.metaData.product.offers.url
                    }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: {
                      itemprop: "priceCurrency",
                      content: _vm.metaData.product.offers.priceCurrency
                    }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: {
                      itemprop: "price",
                      content: _vm.metaData.product.offers.price
                    }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: {
                      itemprop: "priceValidUntil",
                      content: _vm.metaData.product.offers.priceValidUntil
                    }
                  }),
                  _vm._v(" "),
                  _c("link", {
                    attrs: {
                      itemprop: "availability",
                      href: _vm.metaData.product.offers.availability
                    }
                  }),
                  _vm._v(" "),
                  _c("link", {
                    attrs: {
                      itemprop: "itemCondition",
                      href: "https://schema.org/NewCondition"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  attrs: {
                    itemprop: "brand",
                    itemscope: "",
                    itemtype: "https://schema.org/Brand"
                  }
                },
                [
                  _c("meta", {
                    attrs: {
                      itemprop: "logo",
                      content: _vm.metaData.product.brand.logo
                    }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: {
                      itemprop: "name",
                      content: _vm.metaData.product.brand.name
                    }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: {
                      itemprop: "url",
                      content: _vm.metaData.product.brand.url
                    }
                  })
                ]
              ),
              _vm._v(" "),
              "aggregateRating" in _vm.metaData.product
                ? [
                    _c(
                      "div",
                      {
                        attrs: {
                          itemprop: "aggregateRating",
                          itemscope: "",
                          itemtype: "https://schema.org/AggregateRating"
                        }
                      },
                      [
                        _c("meta", {
                          attrs: {
                            itemprop: "ratingValue",
                            content:
                              _vm.metaData.product.aggregateRating.ratingValue
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: {
                            itemprop: "reviewCount",
                            content:
                              _vm.metaData.product.aggregateRating.reviewCount
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: { itemprop: "bestRating", content: "5" }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: { itemprop: "worstRating", content: "1" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.metaData.reviewList, function(review) {
                      return _c(
                        "div",
                        {
                          key: review.id,
                          attrs: {
                            itemscope: "",
                            itemprop: "review",
                            itemtype: "https://schema.org/Review"
                          }
                        },
                        [
                          _c("meta", {
                            attrs: {
                              itemprop: "itemReviewed",
                              content: review.productName
                            }
                          }),
                          _vm._v(" "),
                          _c("meta", {
                            attrs: {
                              itemprop: "datePublished",
                              content: review.date
                            }
                          }),
                          _vm._v(" "),
                          _c("meta", {
                            attrs: {
                              itemprop: "reviewBody",
                              content: review.text
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              attrs: {
                                itemscope: "",
                                itemprop: "author",
                                itemtype: "https://schema.org/Person"
                              }
                            },
                            [
                              _c("meta", {
                                attrs: {
                                  itemprop: "name",
                                  content: review.userName
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "oneReview",
                              attrs: {
                                itemprop: "reviewRating",
                                itemscope: "",
                                itemtype: "https://schema.org/Rating"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    itemscope: "",
                                    itemprop: "author",
                                    itemtype: "https://schema.org/Person"
                                  }
                                },
                                [
                                  _c("meta", {
                                    attrs: {
                                      itemprop: "name",
                                      content: review.userName
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("meta", {
                                attrs: {
                                  itemprop: "ratingValue",
                                  content: review.ratingValue
                                }
                              }),
                              _vm._v(" "),
                              _c("meta", {
                                attrs: { itemprop: "worstRating", content: "1" }
                              }),
                              _vm._v(" "),
                              _c("meta", {
                                attrs: { itemprop: "bestRating", content: "5" }
                              })
                            ]
                          )
                        ]
                      )
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.product
        ? _c("sticky-product-card", { attrs: { product: _vm.product } })
        : _vm._e(),
      _vm._v(" "),
      _vm.product === null
        ? _c("loading-indicator", { attrs: { "is-full-page": true } })
        : _c("div", { staticClass: "container container-small" }, [
            _c(
              "div",
              { staticClass: "mt-5 d-flex justify-content-center" },
              [
                _c("rating-stars", {
                  attrs: {
                    rating: _vm.productRateValue,
                    "is-rate-num-visible": false,
                    "is-review-count-visible": false
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("h1", { staticClass: "page-title text-center my-5" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("termek_vasarloi_velemenyek")) +
                  " " +
                  _vm._s(_vm.productRateValue) +
                  " (" +
                  _vm._s(_vm.reviewCount) +
                  ")\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container-small container" },
              _vm._l(_vm.reviewBarData, function(reviewBar) {
                return _c("review-bar", {
                  key: reviewBar.starCount,
                  staticClass: "my-3 cursor-pointer",
                  attrs: {
                    "star-count": reviewBar.starCount,
                    percent: reviewBar.percent,
                    "is-disabled":
                      !_vm.canFilterCurrentStar(reviewBar.starCount) ||
                      reviewBar.percent === 0,
                    "is-active":
                      _vm.reviewStarFilter !== "" &&
                      _vm.reviewStarFilter === reviewBar.starCount
                  },
                  on: { reviewBarClicked: _vm.selectStarFilter }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "orszag",
                  expression: "'orszag'"
                }
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex my-4" },
              _vm._l(_vm.langFilterList, function(langData) {
                return _c("flag", {
                  key: langData.langKey,
                  staticClass: "mr-3 cursor-pointer flag-block",
                  attrs: {
                    "flag-img-src": langData.flagImgSrc,
                    "lang-key": langData.langKey,
                    "is-large": true,
                    "is-active":
                      _vm.reviewLangFilter !== "" &&
                      _vm.reviewLangFilter === langData.langKey,
                    "is-disabled": !_vm.canFilterCurrentLang(langData.langKey)
                  },
                  on: { flagClicked: _vm.selectLangFilter }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _vm.reviewStarFilter !== "" || _vm.reviewLangFilter !== ""
                ? _c("button", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "clear_review_filter",
                        expression: "'clear_review_filter'"
                      }
                    ],
                    staticClass:
                      "custom-button unfilled mb-1 mt-3 review-page-btn",
                    on: { click: _vm.clearReviewFilters }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.isLoggedIn
              ? _c("div", { staticClass: "text-center" }, [
                  _vm.unAcceptedReviewList.length === 0
                    ? _c("div", [
                        !_vm.isWritingReview
                          ? _c("button", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "en_is_elmondom_a_velemenyem",
                                  expression: "'en_is_elmondom_a_velemenyem'"
                                }
                              ],
                              staticClass:
                                "custom-button mb-5 mt-3 review-page-btn",
                              on: {
                                click: function($event) {
                                  _vm.isWritingReview = true
                                }
                              }
                            })
                          : _c(
                              "div",
                              { staticClass: "new-review-block mb-4" },
                              [
                                _c("div", [
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "ertekeld_csillagokkal",
                                        expression: "'ertekeld_csillagokkal'"
                                      }
                                    ],
                                    ref: "viewOpinion"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center my-3"
                                    },
                                    [
                                      _c("rating-stars", {
                                        attrs: {
                                          "is-rating-enabled": true,
                                          "latest-star-clicked":
                                            _vm.selectedStarForReview,
                                          "is-rate-num-visible": false,
                                          "is-review-count-visible": false
                                        },
                                        on: {
                                          rateClicked: _vm.selectStarForReview
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("custom-input", {
                                  attrs: {
                                    "title-name": _vm.$t(
                                      "velemeny_inputtext_placeholder"
                                    ),
                                    "data-cy": "review-title"
                                  },
                                  model: {
                                    value: _vm.reviewTitle,
                                    callback: function($$v) {
                                      _vm.reviewTitle = $$v
                                    },
                                    expression: "reviewTitle"
                                  }
                                }),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reviewText,
                                      expression: "reviewText"
                                    }
                                  ],
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "velemeny_textarea_placeholder"
                                    ),
                                    "data-cy": "review-body"
                                  },
                                  domProps: { value: _vm.reviewText },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.reviewText = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox ml-4 text-left mt-2"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isModerationAccepted,
                                          expression: "isModerationAccepted"
                                        }
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "moderation-accept-checkbox",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.isModerationAccepted
                                        )
                                          ? _vm._i(
                                              _vm.isModerationAccepted,
                                              null
                                            ) > -1
                                          : _vm.isModerationAccepted
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.isModerationAccepted,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isModerationAccepted = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isModerationAccepted = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isModerationAccepted = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "moderation-accept-checkbox"
                                        }
                                      },
                                      [
                                        _c("text-and-widget-display", {
                                          attrs: {
                                            "text-body": _vm.$t(
                                              "moderation_note"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("button", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "term_kerdesek_elkuld",
                                      expression: "'term_kerdesek_elkuld'"
                                    }
                                  ],
                                  staticClass: "custom-button mt-3",
                                  attrs: {
                                    disabled:
                                      _vm.isReviewAddInProgress ||
                                      _vm.reviewText.trim() === "" ||
                                      !_vm.isSelectedStarValid ||
                                      !_vm.isModerationAccepted,
                                    "data-cy": "review-send"
                                  },
                                  on: { click: _vm.addReview }
                                })
                              ],
                              1
                            )
                      ])
                    : _c(
                        "div",
                        [
                          _vm._l(_vm.unAcceptedReviewList, function(
                            unAcceptedReviewData
                          ) {
                            return _c(
                              "div",
                              {
                                key: unAcceptedReviewData.ID,
                                staticClass: "text-left my-4"
                              },
                              [
                                _c("product-review-card", {
                                  staticClass: "my-2",
                                  attrs: { "review-data": unAcceptedReviewData }
                                }),
                                _vm._v(" "),
                                _c("hr")
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c("div", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "legy_turelemmel_velemeny",
                                expression: "'legy_turelemmel_velemeny'"
                              }
                            ],
                            staticClass: "text-center mb-5"
                          })
                        ],
                        2
                      )
                ])
              : _c(
                  "div",
                  { staticClass: "text-center mb-5" },
                  [
                    _c("router-link", { attrs: { to: "/login" } }, [
                      _c("button", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "login_to_review_item",
                            expression: "'login_to_review_item'"
                          }
                        ],
                        ref: "loginToOpinion",
                        staticClass: "custom-button mt-3"
                      })
                    ])
                  ],
                  1
                ),
            _vm._v(" "),
            !_vm.isLoadInProgress && _vm.productReviewList.length === 0
              ? _c("h3", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "nincs_megjelenitheto_tartalom",
                      expression: "'nincs_megjelenitheto_tartalom'"
                    }
                  ],
                  staticClass: "text-center"
                })
              : _c(
                  "div",
                  _vm._l(_vm.productReviewList, function(reviewData) {
                    return _c(
                      "div",
                      { key: reviewData.ID },
                      [
                        _c("product-review-card", {
                          attrs: {
                            "review-data": reviewData,
                            "is-vote-in-progress":
                              _vm.voteProgresses[reviewData.ID] === true
                          },
                          on: {
                            voteReview: _vm.voteReview,
                            translationClicked: _vm.translateReview
                          }
                        }),
                        _vm._v(" "),
                        _c("hr")
                      ],
                      1
                    )
                  }),
                  0
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center my-5" },
              [
                _vm.isLoadInProgress
                  ? _c("loading-indicator", { attrs: { "is-full-page": true } })
                  : _vm.isMoreReviewAvailable
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "observe-visibility",
                            rawName: "v-observe-visibility",
                            value: _vm.onListEndVisible,
                            expression: "onListEndVisible"
                          }
                        ],
                        staticClass: "text-center load-more-btn"
                      },
                      [
                        _c("span", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "others",
                              expression: "'others'"
                            }
                          ],
                          staticClass: "cursor-pointer",
                          on: { click: _vm.loadProductReviews }
                        })
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }